var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status.value)?_c('v-icon',{staticClass:"status-icon",attrs:{"color":"green"}},[_vm._v("\n  mdi-check-circle-outline\n")]):_c('v-icon',{staticClass:"status-icon",attrs:{"title":_vm.status.label,"color":"red"}},[_vm._v("\n  mdi-close-circle-outline\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }